import React,{ useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { setToken } from "../../store/authSlice";
import { setUserData } from "../../store/user";
import { urlServer } from "../../constants/endpoints";
import { selectVar } from "../../store/conf/confSlice.js";
import {
  DEFAULT
} from "../../constants/mediaTypes.js"
const LoginPage = () => {
  const bkgLogin = useSelector(selectVar("_BKG_LOGIN", DEFAULT));

  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const dispatch = useDispatch();

  const handleLogin = async (e) => {
    e.preventDefault();

    const formData = new URLSearchParams();
    formData.append("username",email);
    formData.append("password",password);

    try {
      console.log ("Logging in with:",urlServer+ "/user/login");
      const response = await fetch(urlServer + "/user/login",{
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData.toString(),
      });

      const data = await response.json();
        console.log("Login successful, token stored.",data?.data);

      if (response.ok && data?.data?.result?.token) {
        const { token,user,favorites,unfinished } = data.data.result;
        dispatch(setToken(token));
        dispatch(setUserData({ user,favorites,unfinished }));
        localStorage.setItem("authToken",token);
        localStorage.setItem("userData",JSON.stringify({ user }));
        alert("Login avvenuto con successo!");
        window.location.href = "/";
      } else {
        alert(data?.message || "Login fallito. Per favore riprova.");
      }
    } catch (error) {
      console.error("Login error:",error);
      alert("Something went wrong during login. Please try again.");
    }
  };

  return (
    <div
      className="relative flex items-center justify-center min-h-screen"
      style={{
        backgroundImage: `url(${bkgLogin})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black opacity-80" />
      {/* Form Netflix-style */}
      <form
        onSubmit={handleLogin}
        className="relative z-10 bg-black bg-opacity-80 p-10 rounded-xl shadow-2xl flex flex-col gap-5 w-full max-w-xl"
        autoComplete="off"
      >
        <h2 className="text-3xl font-bold text-white text-center mb-2 tracking-tight">
          Accedi
        </h2>
        <input
          type="text"
          placeholder="Email"
          value={email}
          autoComplete="username"
          onChange={(e) => setEmail(e.target.value)}
          className="bg-[#e5e7eb] text-black placeholder-gray-500 border-none rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-red-600 text-base"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)}
          className="bg-[#e5e7eb] text-black placeholder-gray-500 border-none rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-red-600 text-base"
          required
        />
        <button
          type="submit"
          className="bg-red-700 hover:bg-red-600 transition-colors duration-200 text-white font-semibold text-lg py-3 rounded-md mt-2"
        >
          Accedi
        </button>
        {/* <div className="flex items-center justify-between text-neutral-400 text-sm mt-2">
          <div>
            <input type="checkbox" id="remember" className="accent-red-600 mr-1" />
            <label htmlFor="remember">Ricordami</label>
          </div>
          <a href="#" className="hover:underline text-neutral-300">
            Hai dimenticato la password?
          </a>
        </div>
        <div className="text-neutral-400 text-sm mt-5 text-center">
          Nuovo su MyTV?{" "}
          <a href="/register" className="text-white font-semibold hover:underline">
            Registrati ora
          </a>
        </div> */}
      </form>
      {/* Logo opzionale: puoi aggiungere il tuo logo */}
      {/* <img src="/logo.svg" alt="Logo" className="absolute top-8 left-8 w-36" /> */}
    </div>
  );
};

export default LoginPage;
